import React from 'react';
import {
  Cushion,
  FlexContainer,
  Shimmer,
  ShimmerAvatar,
  ShimmerTypography,
} from '@pitchero/react-ui';

const EventAttendanceLoadingState = () => (
  <Cushion all="small">
    <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
      <ShimmerAvatar size={40} />
      <ShimmerTypography preset="body--large" width="50%" />
      <Shimmer preset="title" height={28} width={52} radius={14} />
    </FlexContainer>
  </Cushion>
);

export default EventAttendanceLoadingState;
